import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import Row from '@app/components/layout/Row'

export const SearchTitle = ({
  title,
  searchTerm,
  onClick,
}: {
  title?: string
  searchTerm?: string
  onClick: () => void
}) => {
  if (!searchTerm) {
    return title
  }

  return (
    <Row style={{ alignItems: 'center', cursor: 'pointer' }} onClick={onClick}>
      {searchTerm}
      <FontAwesomeIcon
        icon={faXmark}
        style={{
          height: '1.5rem',
          width: '1.5rem',
        }}
      />
    </Row>
  )
}
